import { G as push, X as ensure_array_like, Q as push_element, W as escape_html, T as pop_element, O as attr, Y as maybe_selected, Z as bind_props, K as pop, F as FILENAME, _ as attr_style } from "../../chunks/index.js";
TaskDialog[FILENAME] = "src/lib/components/TaskDialog.svelte";
function TaskDialog($$payload, $$props) {
  push(TaskDialog);
  let dialogEl;
  let mode = "create";
  let model = {
    title: "",
    description: "",
    column: "IDEAS",
    categoryId: "",
    dueDate: "",
    recurrence_day_of_month: ""
  };
  let { categories, saved, deleted } = $$props;
  function reset() {
    mode = "create";
    model = {
      title: "",
      description: "",
      column: "IDEAS",
      categoryId: "",
      dueDate: "",
      recurrence_day_of_month: ""
    };
  }
  function fmtDate(s) {
    if (!s) return "";
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return "";
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${m}-${day}`;
  }
  function open(task) {
    if (task) {
      mode = "edit";
      task.id;
      model = {
        title: task.title || "",
        description: task.description || "",
        column: task.column,
        categoryId: task.categoryId || "",
        dueDate: fmtDate(task.dueDate || void 0),
        recurrence_day_of_month: task.recurrence_day_of_month ?? ""
      };
    } else {
      reset();
    }
    dialogEl.showModal();
  }
  const each_array = ensure_array_like(categories);
  $$payload.out.push(`<dialog class="w-full max-w-2xl rounded-md border p-0 svelte-123sm1f">`);
  push_element($$payload, "dialog", 140, 0);
  $$payload.out.push(`<form class="space-y-4 p-4">`);
  push_element($$payload, "form", 145, 1);
  $$payload.out.push(`<header class="flex items-center justify-between">`);
  push_element($$payload, "header", 146, 2);
  $$payload.out.push(`<h2 class="text-lg font-semibold">`);
  push_element($$payload, "h2", 147, 3);
  $$payload.out.push(`${escape_html(mode === "create" ? "Uus töö" : "Muuda tööd")}</h2>`);
  pop_element();
  $$payload.out.push(` <button type="button" class="text-gray-500 hover:text-gray-700">`);
  push_element($$payload, "button", 148, 3);
  $$payload.out.push(`✕</button>`);
  pop_element();
  $$payload.out.push(`</header>`);
  pop_element();
  $$payload.out.push(` <div class="grid grid-cols-1 gap-4 md:grid-cols-2">`);
  push_element($$payload, "div", 151, 2);
  $$payload.out.push(`<label class="block">`);
  push_element($$payload, "label", 152, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 153, 4);
  $$payload.out.push(`Nimetus *</span>`);
  pop_element();
  $$payload.out.push(` <input class="w-full rounded border px-3 py-2"${attr("value", model.title)} required/>`);
  push_element($$payload, "input", 154, 4);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block">`);
  push_element($$payload, "label", 156, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 157, 4);
  $$payload.out.push(`Kategooria</span>`);
  pop_element();
  $$payload.out.push(` <select class="w-full rounded border px-3 py-2">`);
  push_element($$payload, "select", 158, 4);
  $$payload.select_value = model.categoryId;
  $$payload.out.push(`<option value=""${maybe_selected($$payload, "")}>`);
  push_element($$payload, "option", 159, 5);
  $$payload.out.push(`– pole –</option>`);
  pop_element();
  $$payload.out.push(`<!--[-->`);
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let c = each_array[$$index];
    $$payload.out.push(`<option${attr("value", c.id)}${maybe_selected($$payload, c.id)}>`);
    push_element($$payload, "option", 160, 28);
    $$payload.out.push(`${escape_html(c.name)}</option>`);
    pop_element();
  }
  $$payload.out.push(`<!--]-->`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select>`);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block">`);
  push_element($$payload, "label", 163, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 164, 4);
  $$payload.out.push(`Tähtaeg</span>`);
  pop_element();
  $$payload.out.push(` <input type="date" class="w-full rounded border px-3 py-2"${attr("value", model.dueDate)}/>`);
  push_element($$payload, "input", 165, 4);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block">`);
  push_element($$payload, "label", 167, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 168, 4);
  $$payload.out.push(`Korduv (päev kuus)</span>`);
  pop_element();
  $$payload.out.push(` <input type="number" min="1" max="31" class="w-full rounded border px-3 py-2"${attr("value", model.recurrence_day_of_month)}/>`);
  push_element($$payload, "input", 169, 4);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block md:col-span-2">`);
  push_element($$payload, "label", 177, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 178, 4);
  $$payload.out.push(`Veerg</span>`);
  pop_element();
  $$payload.out.push(` <select class="w-full rounded border px-3 py-2">`);
  push_element($$payload, "select", 179, 4);
  $$payload.select_value = model.column;
  $$payload.out.push(`<option value="IDEAS"${maybe_selected($$payload, "IDEAS")}>`);
  push_element($$payload, "option", 180, 5);
  $$payload.out.push(`Ideed</option>`);
  pop_element();
  $$payload.out.push(`<option value="TODO"${maybe_selected($$payload, "TODO")}>`);
  push_element($$payload, "option", 181, 5);
  $$payload.out.push(`Vajab tegemist</option>`);
  pop_element();
  $$payload.out.push(`<option value="THIS_WEEK"${maybe_selected($$payload, "THIS_WEEK")}>`);
  push_element($$payload, "option", 182, 5);
  $$payload.out.push(`Sellel nädalal</option>`);
  pop_element();
  $$payload.out.push(`<option value="DONE"${maybe_selected($$payload, "DONE")}>`);
  push_element($$payload, "option", 183, 5);
  $$payload.out.push(`Tehtud</option>`);
  pop_element();
  $$payload.select_value = void 0;
  $$payload.out.push(`</select>`);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block md:col-span-2">`);
  push_element($$payload, "label", 186, 3);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 187, 4);
  $$payload.out.push(`Kirjeldus (Markdown)</span>`);
  pop_element();
  $$payload.out.push(` <textarea rows="6" class="w-full rounded border px-3 py-2" placeholder="Kirjelduse Markdown…">`);
  push_element($$payload, "textarea", 188, 4);
  const $$body = escape_html(model.description);
  if ($$body) {
    $$payload.out.push(`${$$body}`);
  }
  $$payload.out.push(`</textarea>`);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  $$payload.out.push(` <footer class="flex items-center justify-between pt-2">`);
  push_element($$payload, "footer", 197, 2);
  if (mode === "edit") {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<button type="button" class="rounded border px-3 py-2 text-red-600">`);
    push_element($$payload, "button", 198, 24);
    $$payload.out.push(`Kustuta</button>`);
    pop_element();
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <div class="ml-auto flex gap-2">`);
  push_element($$payload, "div", 203, 3);
  $$payload.out.push(`<button type="button" class="rounded border px-3 py-2">`);
  push_element($$payload, "button", 204, 4);
  $$payload.out.push(`Tühista</button>`);
  pop_element();
  $$payload.out.push(` <button type="submit" class="rounded bg-blue-600 px-3 py-2 text-white">`);
  push_element($$payload, "button", 205, 4);
  $$payload.out.push(`${escape_html(mode === "create" ? "Lisa töö" : "Salvesta")}</button>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  $$payload.out.push(`</footer>`);
  pop_element();
  $$payload.out.push(`</form>`);
  pop_element();
  $$payload.out.push(`</dialog>`);
  pop_element();
  bind_props($$props, { open });
  pop();
}
TaskDialog.render = function() {
  throw new Error("Component.render(...) is no longer valid in Svelte 5. See https://svelte.dev/docs/svelte/v5-migration-guide#Components-are-no-longer-classes for more information");
};
_page[FILENAME] = "src/routes/+page.svelte";
function _page($$payload, $$props) {
  push(_page);
  let tasks = [];
  let q = "";
  let categories = [];
  let categoryId = "";
  let authenticated = false;
  const columns = [
    { key: "IDEAS", label: "Ideed" },
    { key: "TODO", label: "Vajab tegemist" },
    { key: "THIS_WEEK", label: "Sellel nädalal" },
    { key: "DONE", label: "Tehtud" }
  ];
  async function load() {
    const me = await fetch("/api/auth/me");
    const meJson = await me.json();
    authenticated = meJson.authenticated;
    if (!authenticated) {
      location.href = "/login";
      return;
    }
    const url = new URL("/api/tasks", location.origin);
    tasks = await (await fetch(url)).json();
    tasks = tasks.sort((a, b) => {
      return a.sort_order - b.sort_order;
    });
    categories = await (await fetch("/api/categories")).json();
  }
  function tasksIn(col) {
    return tasks.filter((t) => t.column === col).sort((a, b) => a.sort_order - b.sort_order);
  }
  columns.map((status) => ({
    status,
    items: tasks.filter((task) => task.column === status.key)
  }));
  const each_array = ensure_array_like(categories);
  const each_array_1 = ensure_array_like(columns);
  $$payload.out.push(`<div class="space-y-4 p-4">`);
  push_element($$payload, "div", 198, 0);
  $$payload.out.push(`<header class="flex flex-col gap-2 md:flex-row md:items-center">`);
  push_element($$payload, "header", 199, 1);
  $$payload.out.push(`<input placeholder="Otsi…"${attr("value", q)} class="w-full rounded border px-3 py-2 md:w-80"/>`);
  push_element($$payload, "input", 200, 2);
  pop_element();
  $$payload.out.push(` <select class="w-full rounded border px-3 py-2 md:w-60">`);
  push_element($$payload, "select", 206, 2);
  $$payload.select_value = categoryId;
  $$payload.out.push(`<option value=""${maybe_selected($$payload, "")}>`);
  push_element($$payload, "option", 207, 3);
  $$payload.out.push(`Kõik kategooriad</option>`);
  pop_element();
  $$payload.out.push(`<!--[-->`);
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let c = each_array[$$index];
    $$payload.out.push(`<option${attr("value", c.id)}${maybe_selected($$payload, c.id)}>`);
    push_element($$payload, "option", 208, 26);
    $$payload.out.push(`${escape_html(c.name)}</option>`);
    pop_element();
  }
  $$payload.out.push(`<!--]-->`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select>`);
  pop_element();
  $$payload.out.push(` <button class="ml-auto rounded bg-green-600 px-3 py-2 text-white">`);
  push_element($$payload, "button", 210, 2);
  $$payload.out.push(`+ Uus töö</button>`);
  pop_element();
  $$payload.out.push(` <a href="/categories" class="text-sm text-green-600 hover:underline md:ml-2">`);
  push_element($$payload, "a", 213, 2);
  $$payload.out.push(`Kategooriad</a>`);
  pop_element();
  $$payload.out.push(`</header>`);
  pop_element();
  $$payload.out.push(` <section class="grid grid-cols-1 gap-4 md:grid-cols-4">`);
  push_element($$payload, "section", 216, 1);
  $$payload.out.push(`<!--[-->`);
  for (let $$index_2 = 0, $$length = each_array_1.length; $$index_2 < $$length; $$index_2++) {
    let c = each_array_1[$$index_2];
    const each_array_2 = ensure_array_like(tasksIn(c.key));
    $$payload.out.push(`<div class="rounded-lg bg-gray-50 p-3 shadow-sm">`);
    push_element($$payload, "div", 218, 3);
    $$payload.out.push(`<h2 class="mb-2 font-semibold">`);
    push_element($$payload, "h2", 219, 4);
    $$payload.out.push(`${escape_html(c.label)}</h2>`);
    pop_element();
    $$payload.out.push(` <div${attr("data-columnid", c.key)} class="flex min-h-[200px] flex-col gap-2">`);
    push_element($$payload, "div", 220, 4);
    $$payload.out.push(`<!--[-->`);
    for (let $$index_1 = 0, $$length2 = each_array_2.length; $$index_1 < $$length2; $$index_1++) {
      let item = each_array_2[$$index_1];
      $$payload.out.push(`<article class="rounded border bg-white p-3"${attr("data-sortorder", item.sort_order)}>`);
      push_element($$payload, "article", 226, 6);
      $$payload.out.push(`<div class="flex items-start justify-between">`);
      push_element($$payload, "div", 234, 7);
      $$payload.out.push(`<div class="flex items-start gap-2">`);
      push_element($$payload, "div", 235, 8);
      $$payload.out.push(`<button type="button" class="drag-handle mr-1 p-1 text-gray-400 hover:text-gray-600" aria-label="Liiguta"${attr_style(`background:${item.category?.colorHex}; height:20px;`)}${attr("tabindex", -1)}>`);
      push_element($$payload, "button", 236, 9);
      $$payload.out.push(`<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-3 w-3">`);
      push_element($$payload, "svg", 245, 10);
      $$payload.out.push(`<path d="M10 6h4M10 12h4M10 18h4">`);
      push_element($$payload, "path", 256, 11);
      $$payload.out.push(`</path>`);
      pop_element();
      $$payload.out.push(`</svg>`);
      pop_element();
      $$payload.out.push(`</button>`);
      pop_element();
      $$payload.out.push(` <div>`);
      push_element($$payload, "div", 265, 9);
      $$payload.out.push(`<div class="font-medium">`);
      push_element($$payload, "div", 266, 10);
      $$payload.out.push(`${escape_html(item.title)}</div>`);
      pop_element();
      $$payload.out.push(` `);
      if (item.dueDate) {
        $$payload.out.push("<!--[-->");
        $$payload.out.push(`<div class="text-xs text-gray-500">`);
        push_element($$payload, "div", 267, 28);
        $$payload.out.push(`Tähtaeg: ${escape_html(new Date(item.dueDate).toLocaleDateString())}</div>`);
        pop_element();
      } else {
        $$payload.out.push("<!--[!-->");
      }
      $$payload.out.push(`<!--]--></div>`);
      pop_element();
      $$payload.out.push(`</div>`);
      pop_element();
      $$payload.out.push(` <button class="text-xs text-green-700 hover:underline" title="Muuda">`);
      push_element($$payload, "button", 272, 8);
      $$payload.out.push(`Muuda</button>`);
      pop_element();
      $$payload.out.push(`</div>`);
      pop_element();
      $$payload.out.push(` <button class="text-xs text-green-700 hover:underline" title="Üles">`);
      push_element($$payload, "button", 288, 7);
      $$payload.out.push(`⇑</button>`);
      pop_element();
      $$payload.out.push(` <button class="text-xs text-green-700 hover:underline" title="Alla">`);
      push_element($$payload, "button", 296, 7);
      $$payload.out.push(`⇓</button>`);
      pop_element();
      $$payload.out.push(`</article>`);
      pop_element();
    }
    $$payload.out.push(`<!--]--></div>`);
    pop_element();
    $$payload.out.push(`</div>`);
    pop_element();
  }
  $$payload.out.push(`<!--]--></section>`);
  pop_element();
  $$payload.out.push(` `);
  TaskDialog($$payload, { categories, saved: load, deleted: load });
  $$payload.out.push(`<!----></div>`);
  pop_element();
  pop();
}
_page.render = function() {
  throw new Error("Component.render(...) is no longer valid in Svelte 5. See https://svelte.dev/docs/svelte/v5-migration-guide#Components-are-no-longer-classes for more information");
};
export {
  _page as default
};
